import { useEffect, useState } from 'react';
import { Button, Footer } from '@airbus/components-react';
import { useLanguageContextAPI } from '../../context/LanguageContext';
import { scrollAllToTop } from './scrollAllToTop';
import styles from './footer.module.css';

function Footers() {
  const { t } = useLanguageContextAPI();
  const [version, setVersion] = useState<{ 'app-version': string; 'commit-sha': string } | null>(
    null,
  );

  useEffect(() => {
    async function fetchVersion() {
      const response = await fetch('/version.json');
      if (response.ok) {
        const payload = await response.json();
        setVersion(payload);
      } else {
        setVersion(null);
      }
    }
    fetchVersion();
  }, []);

  const handleBackToTop = () => {
    scrollAllToTop();
  };

  return (
    <>
      <div className={styles.footerBacktotop}>
        <Button variant='ghost' onClick={handleBackToTop}>
          Back to top
        </Button>
      </div>
      {/* Desktop (>= 501px) */}
      <div className={`${styles.footerPage} ${styles.onlyDesktop}`}>
        <Footer
          primaryLinks={[
            {
              label: t('support'),
              href: 'https://sites.google.com/airbus.com/mbdcp/support',
              target: '_blank',
            },
            {
              label: t('privacy-policy'),
              href: '/MBD CP V2 Data Privacy Statement.pdf',
              target: '_blank',
            },
            {
              label: t('release_notes'),
              href: 'https://sites.google.com/airbus.com/mbdcp/release-notes',
              target: '_blank',
            },
          ]}
          copyright={` Airbus ${new Date().getFullYear().toString()} | ${
            version ? version['app-version'] : ''
          }`}
        />
      </div>

      {/* Mobile (< 501px) */}
      <div className={`w-480 ${styles.onlyMobile}`}>
        <Footer
          primaryLinks={[
            {
              label: t('support'),
              href: 'https://sites.google.com/airbus.com/mbdcp/support',
              target: '_blank',
            },
            {
              label: t('privacy-policy'),
              href: '/MBD CP V2 Data Privacy Statement.pdf',
              target: '_blank',
            },
          ]}
          mobileUntil='xxl'
        />
      </div>
    </>
  );
}

export default Footers;
